// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"3eb36b50","45":"c1bef36f","95":"cc514030","126":"db939b4d","192":"8b55953a","417":"6c1c3bde","453":"1b8d8799","541":"4545cd4d","724":"24997c72","965":"fb28d7ad"}[chunkId] + ".chunk.js";
};